const styles = {
  root: {
    padding: '8px 16px',
    outline: 'none',
    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.15)',
    borderRadius: '20px',
    lineHeight: 1,
    '&.MuiIconButton-root:focus': {
      outline: 'none',
    },
  },
};

export default styles;
